"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrderValidForSantanderApplication = exports.isOrderValid = exports.validateOrder = void 0;
const enums_1 = require("../../enums");
const user_1 = require("./user");
const insurance_1 = require("./insurance");
const customer_1 = require("./customer");
const vehicle_1 = require("./vehicle");
const calculation_1 = require("./calculation");
const validateOrder = (order) => {
    let missing = [];
    // ToDo: test for order status
    const calculationValidations = (0, calculation_1.validateCalculation)(order === null || order === void 0 ? void 0 : order.chosenOffer);
    const customerValidations = (0, customer_1.validateCustomer)(order === null || order === void 0 ? void 0 : order.customer);
    const insuranceValidations = (0, insurance_1.validateInsurance)(order === null || order === void 0 ? void 0 : order.insurance);
    const userValidations = (0, user_1.validateUser)(order === null || order === void 0 ? void 0 : order.user);
    const vehiclesValidations = (0, vehicle_1.validateVehicles)(order === null || order === void 0 ? void 0 : order.vehicles);
    return Array.from(new Set([
        ...missing,
        ...calculationValidations,
        ...customerValidations,
        ...insuranceValidations,
        ...userValidations,
        ...vehiclesValidations,
    ]));
};
exports.validateOrder = validateOrder;
const isOrderValid = (order, onlyLookFor = [], ignore = []) => {
    const validations = (0, exports.validateOrder)(order);
    const validationsWithoutIgnore = Array.isArray(ignore) ? validations.filter((v) => !ignore.includes(v)) : validations;
    if (!onlyLookFor || (onlyLookFor === null || onlyLookFor === void 0 ? void 0 : onlyLookFor.length) === 0)
        return validationsWithoutIgnore.length === 0;
    const filteredValidations = validationsWithoutIgnore.filter((v) => onlyLookFor.includes(v));
    return filteredValidations.length === 0;
};
exports.isOrderValid = isOrderValid;
const isOrderValidForSantanderApplication = (order, ignoreValidationsCodes = [], environment) => {
    // ToDo: Remove this test before launching to production!!!
    if (environment !== enums_1.Environments.PRODUCTION) {
        ignoreValidationsCodes.push(enums_1.OrderValidation.MissingCustomerSocialNumber);
    }
    if (environment.startsWith('dev')) {
        ignoreValidationsCodes.push(enums_1.OrderValidation.MissingUserReferenceSantanderId);
    }
    const validations = (0, exports.validateOrder)(order);
    const applicationValidations = validations.filter((v) => !ignoreValidationsCodes.includes(v));
    const isValid = applicationValidations.length === 0;
    if (!isValid) {
        const errorMessage = `The order is not valid. Missing data: ${applicationValidations.join('; ')}`;
        console.error(errorMessage);
        throw new Error(errorMessage);
    }
    return isValid;
};
exports.isOrderValidForSantanderApplication = isOrderValidForSantanderApplication;
//# sourceMappingURL=order.js.map